import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AppContext } from "../../../Contexts/AppContext";
import EmptyData from "../../EmptyData";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import SearchRecord from "../../SearchRecord";

const Products = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [products, setProducts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showDesc, setShowDesc] = useState({});
  const [search, setSearch] = useState("");

  const getProducts = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_MAD_GAMERS_URL}/api/products`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    setProducts(result);
    setIsLoading(false);
  };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["business"].bg
        : context.currentTheme["business"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["business"].text
        : context.currentTheme["business"].dark_text
    );
  }, [context]);
  return !isLoading ? (
    <div
      className="flex min-h-[calc(100vh-56px)] flex-col items-center transition-all duration-500"
      style={{ backgroundColor: currentBG, color: currentText }}
    >
      <div className="z-10 flex w-full items-center px-5 pt-5 xs:px-10 sm:px-20">
        <div className="flex items-center">
          <img
            src={
              context.isLight
                ? `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/logo-light.png`
                : `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/logo-dark.png`
            }
            alt="MadGamers"
            className="w-20 sm:w-28"
          />
          <SearchRecord
            setSearch={setSearch}
            search={search}
            label="Categories"
          />
        </div>
      </div>
      {products?.length > 0 ? (
        <div className="my-5 flex flex-wrap items-center justify-center">
          {products.map(
            (product) =>
              product.category.toLowerCase().includes(search.toLowerCase()) && (
                <div
                  key={product._id}
                  className="relative m-5 flex w-full flex-col overflow-x-hidden rounded-lg xs:w-80 ss:w-96"
                  style={{
                    boxShadow: `0px 2px 6px -2px ${currentText}`,
                  }}
                  onMouseEnter={() => setShowDesc({ [product._id]: true })}
                  onMouseLeave={() => setShowDesc({ [product._id]: false })}
                >
                  <img
                    src={`${process.env.REACT_APP_BACKEND_MAD_GAMERS_URL}/${
                      product.image.split("/")[1]
                    }`}
                    alt="product"
                    className="mb-3 h-64 w-full rounded-t-lg object-cover"
                  />
                  <div className="flex items-center justify-between px-2">
                    <h1 className="text-base font-semibold uppercase ss:text-xl">
                      {product.name}
                    </h1>
                    <p className="text-base ss:text-xl">${product.price}</p>
                  </div>
                  <div className="m-2 mt-4 flex items-center justify-end">
                    <p
                      className="mr-1 self-end rounded-2xl border-2 border-purple-700 px-2 text-sm font-bold text-purple-700 xs:text-base ss:text-base"
                      title="category"
                    >
                      {product.category}
                    </p>
                    <p className="ml-1 self-end rounded-2xl border-2 border-green-500 px-2 text-sm font-bold text-green-500 xs:text-base ss:text-base">
                      from {product.user.name}
                    </p>
                  </div>
                  <AnimatePresence>
                    {showDesc[product._id] && (
                      <motion.div
                        initial={{
                          y: "-16rem",
                        }}
                        animate={{
                          y: 0,
                          transition: {
                            duration: 0.5,
                            ease: "easeInOut",
                          },
                        }}
                        exit={{
                          y: "-16rem",
                          transition: {
                            duration: 0.2,
                            ease: "easeInOut",
                          },
                        }}
                        className="absolute flex h-64 w-full items-center justify-center px-2 text-sm font-bold uppercase text-white backdrop-blur ss:text-base"
                        style={{
                          backgroundColor: "#26172caa",
                        }}
                      >
                        {product.description}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              )
          )}
        </div>
      ) : (
        <EmptyData message="No Products Available now" />
      )}
    </div>
  ) : (
    <LoadingSpinner
      name="Products"
      bgColor={currentBG}
      text={currentText}
      isLight={context.isLight}
    />
  );
};

export default Products;
